import request from './request';
import URL from './url';

const TIMER_DURATION = 5000;

const StatManager = function() {
  this.__timer = 0;
  this.__info = [];
  this.__time = {};

  this.parse = function(e) {
    let { target } = e;
    if (target) {
      let value = target.getAttribute('data-stat');
      if (value) {
        this.__info.push({
          type: 'event',
          linkid: window.pageDetail ? window.pageDetail.link_id : null,
          value: value
        });
      }
    }
  };
  this.__bindParse = this.parse.bind(this);

  this.start = function() {
    this.__timer = setInterval(this.send.bind(this), TIMER_DURATION);
    // 开始监听页面内容
    window.document.body.addEventListener('click', this.__bindParse);

    // 开始监听页面关闭事件
    window.addEventListener('beforeunload', this.__bindClose);
  };

  this.beforeClose = function() {
    Object.keys(this.__time).forEach(item => {
      this.timeEnd(item);
    });
    this.send();
  };
  this.__bindClose = this.beforeClose.bind(this);

  this.stop = function() {
    clearInterval(this.__timer);
    // 去掉监听页面内容
    window.document.body.removeEventListener('click', this.__bindParse);
  };

  this.send = function(options = {}) {
    if (this.__info.length) {
      let all = this.__info.splice(0);

      return request({
        url: '/api/v2/trigger/story',
        method: 'POST',
        type: 'jsonv2',
        data: JSON.stringify(all),
        keepalive: !!options.keepalive,
        credentials: 'include',
        headers: {
          Authorization: request.token
        }
      });
    }

    return Promise.resolve();
  };

  this.page = function(value, extra) {
    this.__info.push({
      type: 'page',
      linkid: window.pageDetail ? window.pageDetail.link_id : null,
      value,
      extra
    });
  };

  this.event = function(value, extra) {
    this.__info.push({
      type: 'event',
      linkid: window.pageDetail ? window.pageDetail.link_id : null,
      value,
      extra
    });
  };

  this.count = function(value) {
    let index = this.__info.findIndex(it => it.value == value);
    if (index > -1) {
      this.__info[index].extra = Math.max(1, this.__info[index].extra + 1);
    } else {
      this.__info.push({
        type: 'event',
        linkid: window.pageDetail ? window.pageDetail.link_id : null,
        value,
        extra: 1
      });
    }
  };

  this.time = function(key, value, extra) {
    this.__time[key] = {
      type: 'event',
      linkid: window.pageDetail ? window.pageDetail.link_id : null,
      value,
      extra: {
        ...extra,
        time: Date.now()
      }
    };
  };

  this.timeEnd = function(key) {
    let item = this.__time[key];
    if (item) {
      item.extra &&
        (item.extra.time = Math.max(
          0,
          Math.ceil((Date.now() - Number(item.extra.time)) / 1000)
        ));
      this.__info.push(item);
      delete this.__time[key];
    }
  };

  this.from = function() {
    let fromStr = 'from_self';
    // 先检测是否url带了from
    let urlParser = URL(window.location.href);
    let urlFrom = urlParser.getParam('from');
    if (urlFrom) {
      fromStr = urlFrom;
      window.sessionStorage.setItem('page_from', fromStr);
    } else {
      let sessionFrom = window.sessionStorage.getItem('page_from');
      if (sessionFrom) {
        fromStr = sessionFrom;
      }
    }

    this.__info.push({
      type: 'event',
      value: fromStr,
      linkid: window.pageDetail ? window.pageDetail.link_id : null
    });

    let iv = urlParser.getParam('iv');
    if(iv) {
      // 判断一下是否为当前用户
      if(iv != window.userinfo.openid) {
        // 判断一下不是mock数据
        // 判断一下后台的设置，是否需要记录非授权用户
        if(Number(window.configDetail.use_invite_auth) == 1) {
          // 用配置去控制了，不管啥情况，没授权就是不记数 2023-03-02
          if(/*window.isweixin && */ window.userinfo.is_mock === true) {
            return false;
          }
          // 判断一下，如果昵称是 微信用户，则也直接干掉
          if(window.userinfo.is_mock === false && window.userinfo.nickname == '微信用户') {
            return false;
          }
        }
        this.__info.push({
          type: 'event',
          value: 'invite_usr',
          linkid: window.pageDetail ? window.pageDetail.link_id : null,
          extra: decodeURIComponent(iv)
        });
      }
    }
  };
};

export default new StatManager();
